// Cookies
    function createCookie(cookieName,cookieValue,daysToExpire) {
        var date = new Date();
        date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
        document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
    }   
    function accessCookie(cookieName) {
        var name = cookieName + "=";
        var allCookieArray = document.cookie.split(';');
        for(var i=0; i<allCookieArray.length; i++) {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
        }
        return "";
    }
    function setCookieCloseBox(cookieName) {
        createCookie(cookieNaam, 'closed', days); // create cookie 
        document.body.removeEventListener("mouseleave", userLeave); // prevent box from reappearing
        document.body.classList.remove('newsletterbox-active'); // hide newsletter box
    }
// Newsletter
// Newsletter (show once per site visit)
function newsletterPopup() {
  var newsletterBox = document.getElementById("newsletterbox");
  if (!newsletterBox) return;

  // ----- SESSION GUARD: only once per browser session -----
  if (sessionStorage.getItem('newspopupShown') === 'true') {
    return; // already shown sometime this session
  }

  // You can keep cookies if you want a longer-term "don't show" too:
  var cookieNaam = "newspopup";
  var isCookie = accessCookie(cookieNaam); // 'closed' means do not show for X days

  // Config from data-attrs (fallbacks)
  var days = newsletterBox.dataset.expire; // for cookie (unused for session-only)
  var cdown = newsletterBox.dataset.cdown;
  var tnx = newsletterBox.dataset.thanks;
  var err  = newsletterBox.dataset.err;
  var mail = newsletterBox.dataset.mail;

  if (days === undefined) days = 7;
  if (cdown === undefined) cdown = 30000;
  if (tnx === undefined) tnx = "Thanks for signing up!";
  if (err  === undefined) err  = "There was an error in submitting the form.";
  if (mail === undefined) mail = "Please fill in your email address.";

  // Show after countdown
  function countDownr() {
    setTimeout(function() {
      document.body.classList.add('newsletter-active'); // show popup
      // Mark as shown for the rest of this browser session
      sessionStorage.setItem('newspopupShown', 'true');
    }, Number(cdown));
  }

  // Close + persist flags
  function setClosedFlagsAndClose() {
    // Keep your cookie to suppress for X days (optional)
    createCookie(cookieNaam, 'closed', days);
    // Always mark session as shown so it won’t appear again this session
    sessionStorage.setItem('newspopupShown', 'true');

    document.body.classList.remove('newsletter-active');
    document.body.removeEventListener("mouseleave", userLeave);
  }

  // Exit-intent (only fires if it hasn’t shown yet)
  function userLeave(event) {
    if (event.clientY <= 0 && sessionStorage.getItem('newspopupShown') !== 'true') {
      document.body.classList.add('newsletter-active');
      sessionStorage.setItem('newspopupShown', 'true');
    }
  }

  // Challenge page guard
  var challengeUrl = window.location.origin + '/challenge#contact_form';
  if (window.location.href === challengeUrl) {
    newsletterBox.style.display = 'none';
    return;
  }

  // If cookie was set to 'closed' (from earlier visits), don't show at all
  if (isCookie === 'closed') {
    sessionStorage.setItem('newspopupShown', 'true'); // also set session, for safety
    return;
  }

  // Start countdown to show once this session
  countDownr();

  // Close buttons should set the flags too
  document.getElementById('closenewsletter')?.addEventListener('click', setClosedFlagsAndClose);
  document.querySelector('button#closenewsletter span.times')?.addEventListener('click', setClosedFlagsAndClose);

  // Optional exit-intent listener; remove if you only want the timer
  document.body.addEventListener("mouseleave", userLeave);

  // AJAX submit (unchanged except: call setClosedFlagsAndClose on success)
  $('form.contact-form').submit(function(){
    $('p.msg.is-green, p.msg.is-red').remove();

    if($(this).find('input[type="email"]').val() !== '') {
      var data = $(this).serialize();
      $.ajax({
        type: "POST",
        url: "/contact#contact_form",
        data: data,
        crossDomain: true,
        success: function(response, textStatus, xhr) {
          $('.contact-form').append('<p class="msg is-green">'+tnx+'</p>');
          setTimeout(function(){ setClosedFlagsAndClose(); }, 3000);
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
          $('.contact-form').append('<p class="msg is-red">'+err+'</p>');
          // If Shopify challenge kicks in, redirect
          if (XMLHttpRequest && XMLHttpRequest.status === 429) {
            window.location = window.location.origin + '/challenge#';
          }
        }
      });

      return false; // prevent default
    } else {
      $(this).append('<p class="msg is-red">'+mail+'</p>');
      return false;
    }
  });
}

// Toggle Body Class
    let toggleBodyClass = function(arg) {
        document.body.classList.toggle(arg);
    }
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
function getSetVh() {
    let vh = window.innerHeight * 0.01;
    document.body.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener('resize', () => {
    getSetVh();
});

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        let elArray = document.querySelectorAll(qSelectors);
        elArray.forEach(function(e) {
            e.addEventListener("click", function() {
                toggleBodyClass(bodyClass);
            });
        });
    }
// Menu
    let toggleMenu = function() { 
        toggleClass('.fire-menu, .shrink-menu', 'open-menu');
    }
// Menu
    let toggleSearch = function() { 
        toggleClass('.fire-search, .shrink-search', 'open-search');
    }
// Cart
    let toggleCart = function() {
        toggleClass('.carto, .cartc', 'open-cart');

        const clsbtn = document.querySelector('.cartc');
        clsbtn.addEventListener('click', () => {
            document.body.classList.remove('hideheader');
        });
    }

// Dropdown menu header
function dropdownMenu() {
    const detailsElements = document.querySelectorAll("details.lv1");

    function handleClickOnDetails() {
      // close all details
      let detailsOpened = document.querySelectorAll("details[open].lv1");

      for (const item of detailsOpened) {
        if (this != item) {
          item.removeAttribute("open");
        }
      }
    }

    detailsElements.forEach(function (item) {
      item.addEventListener("click", handleClickOnDetails);
    });
}

// Close <details> when you click outside
var details = [...document.querySelectorAll('details')];
document.addEventListener('click', function(e) { 
    if (!details.some(f => f.contains(e.target))) { 
        details.forEach(f => f.removeAttribute('open')) 
    } else { 
        details.forEach(f => !f.contains(e.target) ? f.removeAttribute('open') : '') 
    } 
});

// update button price on variant change 
function updatePrice(obj,idd) {
    var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
    var pb = document.querySelector('.uprice'+idd);
    pb.innerText = uid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd) }

// AJAX cart.js
// AJAX cart init can be located in theme.liquid
function ajaxCart(obj) {
    // Show loading feedback
    obj.classList.add('loading');

    // on cart request success
    $(document).ajaxSuccess(function(event, jqxhr, settings) {
        if (settings.url == '/cart/add.js' || settings.url == '/cart/change.js') {
            // on cart request complete (just in case)
            $(document).on('cart.requestComplete', function(event, cart) {
                // Update # of items in cart
                document.getElementById('counter').setAttribute('data-count', cart.item_count);
                // Open cart
                document.body.classList.add('open-cart');
                document.body.classList.add('hideheader');
                // Remove loading feedback
                obj.classList.remove('loading');
            });
        }
    });

    // on cart request error
    $(document).ajaxError(function(event, jqxhr, settings) {
        if (settings.url == '/cart/add.js' || settings.url == '/cart/change.js') {
            obj.classList.remove('loading'); // Remove loading feedback
            console.log(jqxhr.responseJSON);
            alert(jqxhr.responseJSON.description);
            event.stopImmediatePropagation();
        }
    });
}

// Update # of items in cart
$(document).on('cart.requestComplete', function(event, cart) {
    document.getElementById('counter').setAttribute('data-count', cart.item_count);
});

/*** init app */
function app() {
    getSetVh(); // get Viewport Height
    dropdownMenu(); // Dropdown menu
    newsletterPopup(); // Newsletter popup
    toggleMenu(); // toggle Menu
    toggleSearch(); // toggle Search
    toggleCart(); // toggle Cart
    Marquee3k.init(); // Start noticer
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { app() })

/** for quantity **/
$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
}); 

$(".cart-out").detach().appendTo("body");  

var url =  window.location.href;  
let result = url.includes("/challenge");
console.log(result);
if ( result == true )
{
  $("div#newsletterbox").addClass("hide");
  $("div#newsletterbox").hide();
}
$("button#closenewsletter span.times").click(function(){
$("div#newsletterbox").hide();
})



/* === close mobile drawer when crossing 778px ========================== */
(function(){
  var DESKTOP_BP = 778;  // <-- was 1024; your theme switches at 778

  function closeIfDesktop(){
    if (window.innerWidth >= DESKTOP_BP){
      document.body.classList.remove('open-menu','hideheader');
      document.body.style.overflow = '';
    }
  }

  document.addEventListener('DOMContentLoaded', closeIfDesktop);
  window.addEventListener('resize', closeIfDesktop, { passive:true });
  window.addEventListener('orientationchange', closeIfDesktop);
})();
